"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var next_1 = require("@alifd/next");
var task_1 = require("@alife/task");
var config_1 = require("./config");
exports.TASKTYPE = config_1.TASKTYPE;
var idcard_1 = require("./task/idcard");
var manualLogin_1 = require("./task/manualLogin");
var register_1 = require("./task/register");
var doubleConfirm_1 = require("./task/doubleConfirm");
var gpy_1 = require("./task/gpy");
var faceScanAuth_1 = require("./task/faceScanAuth");
var signature_1 = require("./task/signature");
var commentAndRate_1 = require("./task/commentAndRate");
var qrCodeLogin_1 = require("./task/qrCodeLogin");
var Cookie = require("js-cookie");
var selectUserType_1 = require("./task/selectUserType");
var service_1 = require("./task/service");
var contextManage_1 = require("./contextManage");
var esign_1 = require("./task/esign");
var types_1 = require("./types");
exports.TaskProps = types_1.TaskProps;
exports.IdCardProps = types_1.IdCardProps;
exports.GpyProps = types_1.GpyProps;
exports.SignatureProps = types_1.SignatureProps;
exports.EsignProps = types_1.EsignProps;
var taskPropsParam = {
    domain: task_1.Util.getDymanicDomain(),
    expires: 9999,
    path: "/",
};
var TASK = new task_1.default(taskPropsParam);
// tslint:disable-next-line:prefer-const
var timeout = null;
function TaskDialog(props) {
    var _this = this;
    // 声明一个叫做name的state
    var _a = react_1.useState(false), visible = _a[0], setVisible = _a[1];
    var _b = react_1.useState("600px"), width = _b[0], setWidth = _b[1];
    var _c = react_1.useState("430px"), height = _c[0], setHeight = _c[1];
    // 任务的类型
    var _d = react_1.useState(""), status = _d[0], setStatus = _d[1];
    // 任务的进度
    var _e = react_1.useState(""), progress = _e[0], setProgress = _e[1];
    var _f = react_1.useState(""), userType = _f[0], setUserType = _f[1];
    var _g = react_1.useState(""), taskId = _g[0], setTaskId = _g[1];
    var _h = react_1.useState(""), cardNumber = _h[0], setCardNumber = _h[1];
    var _j = react_1.useState(""), cardName = _j[0], setCardName = _j[1];
    var _k = react_1.useState(""), gotoHost = _k[0], setGotoHost = _k[1];
    var _l = react_1.useState([{ label: "身份证", value: "1" }]), selectOpts = _l[0], setSelectOpts = _l[1];
    var _m = react_1.useState(""), activeOption = _m[0], setActiveOtion = _m[1]; // 默认身份证
    var _o = react_1.useState([]), companys = _o[0], setCompanys = _o[1];
    var _p = react_1.useState(true), closeable = _p[0], setCloseable = _p[1]; // 加一个状态判断判断当前Dialog 是否可以关闭
    var _q = react_1.useState(true), taskResult = _q[0], setTaskResult = _q[1]; // 加一个状态判断判断当前Dialog 是否可以关
    react_1.useEffect(function () {
        setWidth(props.originProps.width);
        setHeight(props.originProps.height);
    }, [props.originProps.width, props.originProps.height]);
    react_1.useEffect(function () {
        setStatus(props.originProps.status);
        setUserType(props.originProps.userType);
        setVisible(props.originProps.visible);
        // 初始化peeding状态
        if (props.originProps.visible) {
            setProgress("pending");
        }
    }, [props.originProps.status, props.originProps.userType, props.originProps.visible]);
    react_1.useEffect(function () {
        if (taskId) {
            queryTask();
        }
    }, [taskId]);
    var createTask = function (type, data) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // 先把对话框关闭
                    setCloseable(false);
                    // 创建任务之前 强制把上下文信息传递进去。
                    TASK.context = {
                        idCard: cardNumber,
                        userName: cardName,
                    };
                    return [4 /*yield*/, TASK.createTask(type, data)];
                case 1:
                    result = _a.sent();
                    if (!result) {
                        stopTask();
                    }
                    setTaskId(result);
                    return [2 /*return*/, result];
            }
        });
    }); };
    // 停止任务
    var stopTask = function () {
        closeDialog();
        clear();
    };
    var queryTask = function () {
        if (timeout) {
            window.clearInterval(timeout); // 清除之前的任务
        }
        timeout = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var result, _a, status_1, process, _process;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, TASK.queryTask(null, taskId)];
                    case 1:
                        result = _b.sent();
                        // 判断下是否有任务。
                        setTaskResult(result);
                        if (!taskId) {
                            return [2 /*return*/];
                        }
                        if (result && result.list) {
                            _a = result.list[0], status_1 = _a.type, process = _a.status;
                            _process = [config_1.PROCESS.pending, config_1.PROCESS.processing, config_1.PROCESS.success];
                            if (status_1 === config_1.TASKTYPE.faceScanAuth) {
                                // 扫脸登录
                                _process.push(config_1.PROCESS.failed);
                                if (_process.includes(process)) {
                                    setProgress(process);
                                }
                            }
                            else if (status_1 === config_1.TASKTYPE.qrCodeLogin) {
                                // 扫码登录h5下发
                                if (_process.includes(process)) {
                                    setProgress(process);
                                }
                            }
                            else if (status_1 === config_1.TASKTYPE.signature) {
                                _process.push(config_1.PROCESS.aborted);
                                if (_process.includes(process)) {
                                    setProgress(process);
                                }
                            }
                            else if (status_1 === config_1.TASKTYPE.commentAndRate) {
                                _process = _process.concat([config_1.PROCESS.failed, config_1.PROCESS.aborted]);
                                if (_process.includes(process)) {
                                    setProgress(process);
                                }
                            }
                            else if (status_1 === config_1.TASKTYPE.webViewDisplay) {
                                //处理所有的状态 //如果是 webViewDisplay
                                setProgress(process);
                            }
                            if (process === config_1.PROCESS.expired || process === config_1.PROCESS.failed) {
                                //统一处理expired
                                setTaskId("");
                                setVisible(false);
                                props.originProps.closeDialog();
                                next_1.Message.notice('提交失败');
                                clearInterval(timeout);
                                //
                                props.originProps.fail && props.originProps.fail();
                            }
                            // 清除定时器
                            if (status_1 === config_1.PROCESS.failed) {
                                setTaskId("");
                                clearInterval(timeout);
                                props.originProps.fail && props.originProps.fail();
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); }, 2000);
    };
    var getIdCardInfoFun = function () { return __awaiter(_this, void 0, void 0, function () {
        var info;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, service_1.getIdCardInfo()];
                case 1:
                    info = _a.sent();
                    setSelectOpts(info);
                    if (info[0]) {
                        setActiveOtion(info[0].value);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    //
    react_1.useEffect(function () {
        if (status === config_1.TASKTYPE.manualLogin) {
            // 手动登录的时候需要请求身份证数据
            getIdCardInfoFun();
        }
    }, [status]);
    var setClientUserType = function (type) {
        setUserType(type);
        Cookie.set("clientUserType", type, {
            domain: taskPropsParam.domain,
            path: "/",
        });
    };
    // const isCustomerMade = (status) => {
    //   let result = null;
    //   if (customMade.length > 0) {
    //     customMade.some((cust) => {
    //       if (cust.status === status) {
    //         result = cust;
    //         return true;
    //       }
    //     });
    //   }
    //   return result;
    // };
    var closeDialog = function () { return __awaiter(_this, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!taskId) return [3 /*break*/, 2];
                    return [4 /*yield*/, TASK.updateTask("aborted", taskId)];
                case 1:
                    success = _a.sent();
                    if (success) {
                        setTaskId("");
                        clear();
                        props.originProps.closeDialog();
                    }
                    return [2 /*return*/];
                case 2:
                    setTaskId("");
                    clear();
                    props.originProps.closeDialog();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var clear = function () {
        if (timeout) {
            clearInterval(timeout);
        }
    };
    var renderContext = function () {
        //
        // const TargetCustomerMade = isCustomerMade(status);
        if (status === config_1.TASKTYPE.selectUserType) {
            // 选择个人 or 法人的选项
            var opts = {
                selectUserType: setClientUserType,
            };
            return React.createElement(selectUserType_1.default, __assign({}, opts));
        }
        // 读卡器
        if (status === config_1.TASKTYPE.idCard) {
            return React.createElement(idcard_1.default, null);
        }
        // 扫脸登录功能
        if (status === config_1.TASKTYPE.faceScanAuth) {
            var opts = {
                matterType: props.originProps.matterType,
                matterId: props.originProps.matterId,
                channelCode: props.originProps.channelCode,
            };
            return React.createElement(faceScanAuth_1.default, __assign({}, opts));
        }
        // 下发签名功能
        if (status === config_1.TASKTYPE.signature) {
            return React.createElement(signature_1.default, null);
        }
        //下发签张
        if (status === config_1.TASKTYPE.esign) {
            var params = {
                padUrl: props.originProps.padUrl,
            };
            return React.createElement(esign_1.default, __assign({}, params));
        }
        // 评价功能
        if (status === config_1.TASKTYPE.commentAndRate) {
            var opts = {
                serviceNo: props.originProps.serviceNo,
            };
            return React.createElement(commentAndRate_1.default, __assign({}, opts));
        }
        // 法人登录
        if (status === config_1.TASKTYPE.qrCodeLogin) {
            return React.createElement(qrCodeLogin_1.default, null);
        }
        // 高拍仪
        if (status === config_1.TASKTYPE.gpy) {
            var opts = {
                gpyTotal: props.originProps.gpyTotal,
                fail: props.originProps.fail,
                width: props.originProps.width,
                height: props.originProps.height,
            };
            return React.createElement(gpy_1.default, __assign({}, opts));
        }
        if (status === config_1.TASKTYPE.manualLogin) {
            // 登录界面
            var opts = {
                companys: companys,
                activeOption: activeOption,
                setCompanys: setCompanys,
                selectOpts: selectOpts,
                setSelectOpts: setSelectOpts,
                setActiveOtion: setActiveOtion,
            };
            return React.createElement(manualLogin_1.default, __assign({}, opts));
        }
        if (status === config_1.TASKTYPE.register) {
            var opts = {
                goto: props.originProps.goto,
                task: TASK,
            };
            return React.createElement(register_1.default, __assign({}, opts));
        }
        if (status === config_1.TASKTYPE.doubleConfirm) {
            return React.createElement(doubleConfirm_1.default, { name: cardName, idCard: cardNumber, goto: props.originProps.goto, cardType: activeOption, selectOpts: selectOpts, company: companys, setStatus: setStatus });
        }
        //判断是否是用户自定义的状态
        // if (TargetCustomerMade) {
        //   const CustomerMade = TargetCustomerMade.customMade;
        //   const props = TargetCustomerMade.props;
        //   return <CustomerMade {...props} />;
        // }
    };
    var renderTitle = function () {
        if (status === "gpy") {
            return React.createElement("div", { style: { fontSize: "16px" } }, "\u9AD8\u62CD\u4EEA\u4E0A\u4F20\u6750\u6599");
        }
        if (status === "register") {
            return React.createElement("div", { style: { color: "#333333", fontSize: "16px", fontWeight: "bold" } });
        }
        return "";
    };
    var context = {
        progress: progress,
        setStatus: setStatus,
        taskResult: taskResult,
        cardName: cardName,
        cardNumber: cardNumber,
        userType: userType,
        width: width,
        setWidth: setWidth,
        height: height,
        setHeight: setHeight,
        setUserType: setUserType,
        clear: clear,
        setCardNumber: setCardNumber,
        setCardName: setCardName,
        setGotoHost: setGotoHost,
        setProgress: setProgress,
        success: props.originProps.success,
        closeDialog: closeDialog,
        createTask: createTask,
        fail: props.originProps.fail,
        only: props.only,
    };
    return (React.createElement(contextManage_1.DeviceTaskContext.Provider, { value: context },
        React.createElement(next_1.Dialog, { style: { width: width }, height: height, visible: visible, footer: React.createElement("div", null), isFullScreen: true, onClose: closeDialog, closeable: closeable, title: renderTitle() },
            React.createElement("div", { className: "dating_task_dialog_wap" }, renderContext()))));
}
exports.default = TaskDialog;
